export const SALES_STATISTICS_PER_TYPE =
  '/statistics-service/statistics/sales-statistics/{documentType}/{statisticType}';
export const SALES_STATISTICS_DOCUMENT_TYPES =
  '/statistics-service/statistics/sales-statistics/document-types';
export const SALES_STATISTICS_STATISTIC_TYPES =
  '/statistics-service/statistics/sales-statistics/statistic-types';
